import { find } from 'lodash';
import { RootState } from '..';

export const selectTemplate = (state: RootState, name?: string, id?: string) => {
  if (!id && !name) return;
  return find(state.site.templates, item => item.name === name || item.id === id);
};
